import React from "react";
import TextFieldInput from "../../components/TextFieldInput";
import { Alert, Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import FormLayoutHeader from "../../layoutComponents/FormLayout/FormLayoutHeader";

const PhoneEmailVerification = () => {
	const {
		formState: { errors },
		reset,
		control,
		setValue,
	} = useFormContext();
	return (
		<div>
			<FormLayoutHeader title="Ověření" />
			<Box sx={{ marginBottom: "1.5rem", lineHeight: "24px" }}>
				<p>Pro ověření, zadejte prosím váš email.</p>
			</Box>
				<TextFieldInput
					name="email"
					control={control}
					label="E-mail"
					reset={reset}
					errors={errors}
					defaultValue=""
					setValue={setValue}
					tabValue={1}
				/>
			{errors.root?.serverError.type === "ERR_BAD_RESPONSE" && <Alert severity="error">server response message</Alert>}
		</div>
	);
};

export default PhoneEmailVerification;
